"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

export { AsyncState };

var AsyncState = function AsyncState(initialState, update) {
  _classCallCheck(this, AsyncState);

  this.state = void 0;
  this.runUpdate = void 0;
  deepFreeze(initialState);
  var stateObject = copy(initialState);
  this.state = new Proxy(stateObject, {
    set: set
  });
  this.runUpdate = runUpdate;
  var lastUpdateNumber = 0;
  var updatePromise;
  return this;

  function set(_, prop, val) {
    stateObject[prop] = val;
    runUpdate();
    return true;
  }

  function runUpdate() {
    var updateNumber = lastUpdateNumber = lastUpdateNumber + 1;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var isNotLastUpdate;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return updatePromise;

            case 2:
              isNotLastUpdate = function isNotLastUpdate() {
                return updateNumber !== lastUpdateNumber;
              };

              if (!isNotLastUpdate()) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              updatePromise = update(isNotLastUpdate);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};

function copy(obj) {
  var copy = JSON.parse(JSON.stringify(obj));
  return copy;
} // Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze


function deepFreeze(object) {
  // Retrieve the property names defined on object
  var propNames = Object.getOwnPropertyNames(object); // Freeze properties before freezing self

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = propNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var name = _step.value;
      var value = object[name];

      if (value && _typeof(value) === "object") {
        deepFreeze(value);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return Object.freeze(object);
}